module.exports = __webpack_public_path__ + "img/img101.f0d72ad1.svg";